import { render } from "./ChangeLanguageModal.vue?vue&type=template&id=3b441516&scoped=true"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js"

import "./ChangeLanguageModal.vue?vue&type=style&index=0&id=3b441516&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b441516"]])

export default __exports__